import React, { useCallback } from "react";
import { IconButton } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import SearchInput from "../../SearchInput";
import { CloseIcon } from "../../../../icons";
var useStyles = makeStyles(createStyles({
    wrapper: {
        zIndex: 1,
        display: "grid",
        height: 82,
        padding: "16px 16px 0 16px",
        gap: "16px",
        backgroundImage: "linear-gradient(to bottom right, #e6007d, #e72647)",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
    },
    icon: {
        gridArea: "1 / 1 / 2 / 2",
        placeSelf: "center start",
        padding: 0,
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    title: {
        gridArea: "1 / 1 / 2 / 2",
        placeSelf: "start center",
        fontSize: 20,
        fontWeight: 800,
        lineHeight: "26px",
        color: "#fff",
    },
    search: {
        height: 56,
        padding: "0 16px",
        borderRadius: 8,
        boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.1)",
        border: "solid 1px #d8d8d8",
        backgroundColor: "#fff",
    },
    focus: {
        border: "solid 1px #1d7fe3",
    },
}));
var TopBar = function (_a) {
    var onClose = _a.onClose;
    var styles = useStyles();
    var handleClose = useCallback(onClose, [onClose]);
    return (React.createElement("div", { className: styles.wrapper },
        React.createElement(IconButton, { className: styles.icon, onClick: handleClose, id: "headerDrawer", disableRipple: true },
            React.createElement(CloseIcon, { color: "#fff" })),
        React.createElement("div", { className: styles.title }, "Menu"),
        React.createElement(SearchInput, { classes: { root: styles.search, focused: styles.focus }, mobile: true })));
};
export default TopBar;
